import LanguageIcon from '@mui/icons-material/Language'
import { colorTextTertiary } from '~/styles/textColors'
import {
  HamburgerMenuItemButton,
  type HamburgerMenuItemProps,
} from '../HamburgerMenuItem/HamburgerMenuItem'
import type { ListItemButtonProps } from '@mui/material'

type Props = Pick<HamburgerMenuItemProps, 'disabled' | 'selected'> &
  Pick<ListItemButtonProps, 'onClick'>

export function HamburgerMenuLanguageItem({
  onClick,
  disabled,
  selected,
}: Props) {
  return (
    <HamburgerMenuItemButton
      text="Language"
      icon={<LanguageIcon sx={{ color: colorTextTertiary }} />}
      onClick={onClick}
      disabled={disabled}
      selected={selected}
    />
  )
}
